function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { ManifestRuntimeContext } from './ManifestRuntimeContext';
import { createEditorPlatformManifestServicesError, EditorPlatformManifestServicesErrorCode } from '../errors';
import { hash } from '../hash';
import { ManifestContextAPI } from './ManifestContextAPI';
var _manifestRuntimeContext = /*#__PURE__*/new WeakMap();
var _manifestRuntimeContextBuilders = /*#__PURE__*/new WeakMap();
var _ManifestContextService_brand = /*#__PURE__*/new WeakSet();
export class ManifestContextService {
  constructor(manifestContextAPIProvider, manifestChangeDetection, editorPointerAPI) {
    this.manifestContextAPIProvider = manifestContextAPIProvider;
    this.manifestChangeDetection = manifestChangeDetection;
    this.editorPointerAPI = editorPointerAPI;
    _classPrivateMethodInitSpec(this, _ManifestContextService_brand);
    _classPrivateFieldInitSpec(this, _manifestRuntimeContext, new ManifestRuntimeContext());
    _classPrivateFieldInitSpec(this, _manifestRuntimeContextBuilders, {});
    _assertClassBrand(_ManifestContextService_brand, this, _initChangeDetection).call(this);
  }
  getAllRuntimeContexts() {
    return _classPrivateFieldGet(_manifestRuntimeContext, this).getAll();
  }
  onChange(manifestContextId, cb) {
    return this.manifestChangeDetection.onChange(manifestContextId, cb);
  }
  buildManifestContext(cb) {
    const manifestContextId = `mxf-${hash()}`;
    const factory = () => {
      if (!this.editorPointerAPI) {
        return null;
      }
      const builder = this.manifestContextAPIProvider.getContextBuilder();

      /**
       * we can accept custom builders, returned from the builder function
       * otherwise, fallback to native builder
       */
      const _builder = cb(builder);
      return (_builder ?? builder).build(manifestContextId);
    };
    _classPrivateFieldGet(_manifestRuntimeContextBuilders, this)[manifestContextId] = factory;
    return factory();
  }
  registerContext(manifestRuntimeContext) {
    _classPrivateFieldGet(_manifestRuntimeContext, this).register(manifestRuntimeContext);
  }
  cleanManifestContext(manifestContextId) {
    _classPrivateFieldGet(_manifestRuntimeContext, this).clean(manifestContextId);
  }
  replaceManifestContext(manifestId, context) {
    _classPrivateFieldGet(_manifestRuntimeContext, this).replaceManifestContext(manifestId, context);
    this.manifestChangeDetection.triggerManifestChange(manifestId);
  }
  getContextualManifest(manifestContextId) {
    return _classPrivateFieldGet(_manifestRuntimeContext, this).getManifest(manifestContextId);
  }
  getContextualRuntimeContext(manifestContextId) {
    return _classPrivateFieldGet(_manifestRuntimeContext, this).getRuntimeContext(manifestContextId);
  }
  getContextualManifestResolver(manifestContextId, childPath) {
    if (childPath === void 0) {
      childPath = [];
    }
    const runtimeManifestContext = this.getContextualRuntimeContext(manifestContextId);
    if (!runtimeManifestContext) {
      throw createEditorPlatformManifestServicesError(EditorPlatformManifestServicesErrorCode.ContextualManifestDoesNotExist).withMessage('contextual manifest is required for ManifestResolver');
    }

    /**
     * TODO: probably we need deep merge for handlers
     * TODO: probably we need to support external handlers for resolvers
     */
    return new ManifestContextAPI({
      ...this.manifestContextAPIProvider.getManifestQueryAPI(),
      ...runtimeManifestContext.handlers
    }, this.manifestContextAPIProvider.getManifestResolverAPI(), runtimeManifestContext, childPath).resolver;
  }
  getContextualManifestQuery(manifestContextId, childPath) {
    if (childPath === void 0) {
      childPath = [];
    }
    const runtimeManifestContext = this.getContextualRuntimeContext(manifestContextId);
    if (!runtimeManifestContext) {
      throw createEditorPlatformManifestServicesError(EditorPlatformManifestServicesErrorCode.ContextualManifestDoesNotExist).withMessage('contextual manifest is required for ManifestQuery');
    }

    /**
     * TODO: probably we need deep merge for handlers
     * TODO: probably we need to support external handlers for resolvers
     */
    return new ManifestContextAPI({
      ...this.manifestContextAPIProvider.getManifestQueryAPI(),
      ...runtimeManifestContext.handlers
    }, this.manifestContextAPIProvider.getManifestResolverAPI(), runtimeManifestContext, childPath).query;
  }
}
function _initChangeDetection() {
  this.manifestChangeDetection.onChange(null, () => {
    /**
     * TODO: uncomment when ready
     */
    // void this.#manifestRuntimeContext.map((manifest) => {
    //   const factory =
    //     this.#manifestRuntimeContextBuilders[manifest.manifestId];
    //
    //   if (!factory) {
    //     return null;
    //   }
    //
    //   return factory();
    // });
  });
}
//# sourceMappingURL=ManifestContextService.js.map